import {v1 as uuid} from 'uuid';
import ShortUniqueId from 'short-unique-id';

export const uuidShort8 = new ShortUniqueId({length: 8});

export const generateBlockId = (): string => {
    // 前缀中 doc 后的 yg 表示 young genertion，郝栩彬起的，表示目前块 id 和块引用是一个新生的中间状态，还不是最理想状态
    return 'docyg-' + uuid();
};

export const isStringOrNull = (s?: any): s is string => {
    return !s || typeof s === 'string';
};
